import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import App from './App'; // Anda bisa pakai sebagai layout atau halaman utama
import HomePage from './Pages/index';
import AuthPage from './Pages/AuthPage';
import LoginPage from './Pages/LoginPage';
import reportWebVitals from './reportWebVitals';
import ResultPage from './Pages/ResultPage';
import CertificatePage from './Pages/CertificatePage';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Route utama ke homepage */}
        <Route path="/app" element={<HomePage />} />

        <Route path="/app/result" element={<ResultPage />} />
        {/* Route ke halaman login */}
        <Route path="/app/login" element={<LoginPage />} />
        {/* Route ke halaman auth atau dashboard */}
        <Route path="/app/auth" element={<AuthPage />} />
        <Route path="/app/certificate" element={<CertificatePage />} />
        {/* Optional: tambahkan route fallback */}
        <Route path="*" element={<h1>404 Not Found</h1>} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
